import TranslatedActionButton from './ActionButton.component';

export default TranslatedActionButton;
